import { spawn } from 'redux-saga/effects';
import model from './model/sagas';

export default function* baremetalSaga() {
	yield spawn(model);
}
